module.exports = __webpack_public_path__ + "img/L1060608.71b34ba7.jpg";